import { Modal } from 'antd';
import React from 'react';
import styled from 'styled-components';
import translations from 'translations';
import { Language } from 'types/schema';
import messages from './messages';

const AModal = styled(Modal)`
  .ant-modal-title {
    text-align: center !important;
    font-size: 20px !important;
    font-weight: 500 !important;
    line-height: 26px !important;
    color: #2f382c !important;
  }
  .ant-modal-close {
    top: 16px !important;
  }
  .ant-modal-close-x {
    font-size: 18px !important;
  }
`;

const PolicyModalTitle = styled.h2`
  font-size: 30px;
  font-weight: 700;
  line-height: 39px;
  color: #2f382c;
  margin-bottom: 12px;
`;

const PolicyTermSection = styled.div`
  margin-bottom: 16px;
`;

const PolicyModalTitleSection = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 20.8px;
  color: #000000;
  margin-bottom: 6px;
`;

const PolicyModalTermItem = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #808289;
  line-height: 18px;
`;

const PolicyModalTermDotItem = styled.div`
  width: 5px;
  height: 5px;
  background: #808289;
  border-radius: 4px;
  flex-shrink: 0;
`;

interface PolicyModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}
const PolicyModal = ({ open, setOpen }: PolicyModalProps) => {
  const lang = localStorage.getItem('lang') || Language.Vi;

  const dataEn = [
    {
      term: 'Eligibility',
      termItem: ['The referral program is open to all Kamereo users with an active account.'],
    },
    {
      term: 'Referral Code Usage',
      termItem: [
        'Your unique referral code must be used by your friends during their sign-up process to qualify for rewards.',
        'The referral code can be shared via social media, email, or direct message.',
        'Referral codes cannot be posted on coupon sites or publicly available websites.',
      ],
    },
    {
      term: 'Referral Rewards',
      termItem: [
        'Both you and your referred friend will receive rewards once the friend completes their first order on Kamereo.',
        "Rewards will be credited to your Kamereo account within 7 days after the referred friend's order is successfully completed.",
        'The specific rewards may vary based on ongoing promotions and offers at the time of the referral.',
      ],
    },
    {
      term: 'General Terms',
      termItem: [
        'By participating in the referral program, you agree to abide by these terms and conditions.',
        'These terms and conditions are governed by the laws of the jurisdiction in which Kamereo operates.',
        'For any questions or concerns regarding the referral program, please contact our customer support team at support@kamereo.vn.',
      ],
    },
  ];
  return (
    <AModal
      destroyOnHidden={false}
      // title={translations(utilMessages.deliveryPolicy)}
      closable={true}
      open={open}
      footer={null}
      onCancel={() => {
        setOpen(false);
      }}
    >
      <PolicyModalTitle>{translations(messages.termPolicy)}</PolicyModalTitle>
      {dataEn.map((dt, index) => (
        <PolicyTermSection key={index}>
          {index === dataEn?.length - 1 && (
            <div style={{ background: '#EAEAEB', height: '1px', width: '100%', marginBottom: '16px' }}></div>
          )}
          <PolicyModalTitleSection>{`${index !== dataEn?.length - 1 ? `${index + 1}.` : ''} ${dt.term}`}</PolicyModalTitleSection>
          <div style={{display: 'flex', flexDirection: 'column', gap: '2px'}}>
            {dt.termItem.map((term, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <PolicyModalTermDotItem />
                <PolicyModalTermItem>{term}</PolicyModalTermItem>
              </div>
            ))}
          </div>
        </PolicyTermSection>
      ))}
    </AModal>
  );
};

export default PolicyModal;
